var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      _c("h2", { staticClass: "pg_title" }, [
        _vm._v("Local Service Bulletin - Mobile (Other Language) Edit")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic Info.")]),
      _vm._v(" "),
      _c("table", { staticClass: "create_table" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", [
              _c("th", [
                _vm._v("\n                        Date\n                    ")
              ]),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.REG_DT,
                        expression: "edit.REG_DT"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: { type: "text", placeholder: "", readonly: "" },
                    domProps: { value: _vm.edit.REG_DT },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.edit, "REG_DT", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(
                  "\n                        Register\n                    "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.REG_USER_ID,
                        expression: "edit.REG_USER_ID"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: { type: "text", placeholder: "", readonly: "" },
                    domProps: { value: _vm.edit.REG_USER_ID },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.edit, "REG_USER_ID", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Type")]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.TYPE1,
                        expression: "edit.TYPE1"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    attrs: { disabled: "" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.edit,
                            "TYPE1",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function($event) {
                          _vm.edit.TYPE2 = ""
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "Guide" } }, [
                      _vm._v("Guide")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Bulletin" } }, [
                      _vm._v("Bulletin")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("th", [_vm._v("Subtype")]),
              _vm._v(" "),
              _c("td", [
                _vm.edit.TYPE1 === "Guide"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit.TYPE2_G,
                            expression: "edit.TYPE2_G"
                          },
                          { name: "validation", rawName: "v-validation" }
                        ],
                        ref: "TYPE2G",
                        staticClass: "slt_white w100p",
                        attrs: { disabled: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.edit,
                              "TYPE2_G",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select Inquiry type")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Common" } }, [
                          _vm._v("Common")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "IMEI" } }, [
                          _vm._v("IMEI")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Policy / Process" } }, [
                          _vm._v("Policy / Process")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "SW Tool" } }, [
                          _vm._v("SW Tool")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Jig / Equipment" } }, [
                          _vm._v("Jig / Equipment")
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Training Material" } },
                          [_vm._v("Training Material")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.edit.TYPE1 === "Bulletin"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit.TYPE2_B,
                            expression: "edit.TYPE2_B"
                          },
                          { name: "validation", rawName: "v-validation" }
                        ],
                        ref: "TYPE2B",
                        staticClass: "slt_white w100p",
                        attrs: { disabled: "" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.edit,
                              "TYPE2_B",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select Inquiry type")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.bulletinType2List, function(item) {
                          return _c(
                            "option",
                            { key: item, domProps: { value: item } },
                            [_vm._v(_vm._s(item))]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        Urgency\n                    "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("label", { staticClass: "radiobox-wrap mr10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.URGENCY_YN,
                        expression: "edit.URGENCY_YN"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "",
                      value: "N",
                      disabled: ""
                    },
                    domProps: { checked: _vm._q(_vm.edit.URGENCY_YN, "N") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.edit, "URGENCY_YN", "N")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", [_vm._v("Normal")])
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "radiobox-wrap" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.URGENCY_YN,
                        expression: "edit.URGENCY_YN"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "",
                      value: "Y",
                      disabled: ""
                    },
                    domProps: { checked: _vm._q(_vm.edit.URGENCY_YN, "Y") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.edit, "URGENCY_YN", "Y")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", { staticClass: "txt_red" }, [_vm._v("Urgency")])
                ])
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(
                  "\n                        Need Translation\n                    "
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("label", { staticClass: "radiobox-wrap mr10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.NEED_REPROCESS,
                        expression: "edit.NEED_REPROCESS"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "",
                      value: "Y",
                      disabled: ""
                    },
                    domProps: { checked: _vm._q(_vm.edit.NEED_REPROCESS, "Y") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.edit, "NEED_REPROCESS", "Y")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", { staticClass: "txt_red" }, [_vm._v("Need")])
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "radiobox-wrap" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.NEED_REPROCESS,
                        expression: "edit.NEED_REPROCESS"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "",
                      value: "N",
                      disabled: ""
                    },
                    domProps: { checked: _vm._q(_vm.edit.NEED_REPROCESS, "N") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.edit, "NEED_REPROCESS", "N")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", [_vm._v("Not Need")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(2),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.TITLE,
                        expression: "edit.TITLE"
                      },
                      { name: "validation", rawName: "v-validation" },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    ref: "title",
                    staticClass: "text_input w100",
                    attrs: { type: "text", minlength: "5", maxlength: "200" },
                    domProps: { value: _vm.edit.TITLE },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.edit, "TITLE", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Tag Info")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit.TAG_INFO,
                        expression: "edit.TAG_INFO"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: {
                      type: "text",
                      minlength: "2",
                      maxlength: "200",
                      disabled: "",
                      value: ""
                    },
                    domProps: { value: _vm.edit.TAG_INFO },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.edit, "TAG_INFO", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "userlevel", attrs: { colspan: "3" } },
                [
                  _c("div", { staticClass: "check_wrap w260p" }, [
                    _c("label", { staticClass: "checkbox-wrap mr5" }, [
                      _c("input", {
                        ref: "checkboxUserLevelAll",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked:
                            _vm.checkedUserLevelList.length ===
                            _vm.allUserLevelList.length
                        },
                        on: {
                          change: function($event) {
                            return _vm.onUserLevelAllCheckboxChange($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "check-icon" })
                    ]),
                    _vm._v(" "),
                    _c("em", [_vm._v("All")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.userLevelList, function(item) {
                    return _c(
                      "div",
                      { key: item.CODE_ID, staticClass: "check_wrap w260p" },
                      [
                        _c("label", { staticClass: "checkbox-wrap mr5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedUserLevelList,
                                expression: "checkedUserLevelList"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.CODE_ID,
                              checked: Array.isArray(_vm.checkedUserLevelList)
                                ? _vm._i(
                                    _vm.checkedUserLevelList,
                                    item.CODE_ID
                                  ) > -1
                                : _vm.checkedUserLevelList
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.checkedUserLevelList,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item.CODE_ID,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.checkedUserLevelList = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.checkedUserLevelList = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.checkedUserLevelList = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]),
                        _vm._v(" "),
                        _c("em", [
                          _vm._v(
                            _vm._s(item.CODE_ID) +
                              "(" +
                              _vm._s(item.CODE_NAME) +
                              ")"
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        Subsidary\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ico_pen",
                    on: { click: _vm.selectSubsidiaryPopup }
                  },
                  [_vm._v("pen아이콘")]
                )
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c(
                  "ul",
                  { staticClass: "ul_list" },
                  _vm._l(_vm.selectedSubsidiaryList, function(item) {
                    return _c(
                      "li",
                      { key: item, staticClass: "userlevel_txt" },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "userlevel", attrs: { colspan: "3" } },
                [
                  _vm.availableCountryList.length === 0
                    ? _c("div", [
                        _vm._v(
                          "\n                            Please select subsidiary first.\n                        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.availableCountryList.length > 0
                    ? _c("div", { staticClass: "check_wrap w260p" }, [
                        _c("label", { staticClass: "checkbox-wrap mr5" }, [
                          _c("input", {
                            ref: "checkboxCountryAll",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked:
                                _vm.checkedCountryList.length ===
                                _vm.availableCountryList.length
                            },
                            on: {
                              change: function($event) {
                                return _vm.onCountryAllCheckboxChange($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]),
                        _vm._v(" "),
                        _c("em", [_vm._v("All")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.availableCountryList, function(item) {
                    return _c(
                      "div",
                      { key: item.CODE_ID, staticClass: "check_wrap w260p" },
                      [
                        _c("label", { staticClass: "checkbox-wrap mr5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedCountryList,
                                expression: "checkedCountryList"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.CDCODE,
                              checked: Array.isArray(_vm.checkedCountryList)
                                ? _vm._i(_vm.checkedCountryList, item.CDCODE) >
                                  -1
                                : _vm.checkedCountryList
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.checkedCountryList,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item.CDCODE,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.checkedCountryList = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.checkedCountryList = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.checkedCountryList = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(item.CDDESC))])
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [
                  _c("cross-editor", {
                    attrs: {
                      editorId: "bulletin",
                      editorData: _vm.edit.CONTENT
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.translationLanguages, function(language) {
              return _c("tr", { key: language }, [
                _c("th", [_vm._v("Attachment (" + _vm._s(language) + ")")]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "no_padding", attrs: { colspan: "3" } },
                  [
                    _vm.toTranslateList.includes(language) &&
                    !_vm.isLoading[language]
                      ? _c(
                          "div",
                          [
                            _c("innorix-upload", {
                              attrs: {
                                id: language,
                                name: language,
                                uploadId: language,
                                serviceType: "hhpsvc",
                                onlyUpload: false,
                                attachList: _vm.fileList[language]
                              },
                              on: { files: _vm.setAttachFiles }
                            })
                          ],
                          1
                        )
                      : _vm.toTranslateList.includes(language) &&
                        _vm.isLoading[language]
                      ? _c("span", [
                          _vm._v(
                            "\n                            Loading...\n                        "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }, [
        _c(
          "a",
          {
            staticClass: "btn_white",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$router.push({
                  name: "hhpServiceBulletinOtherView",
                  query: { seq: _vm.seq }
                })
              }
            }
          },
          [_vm._v("View")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn_right" }, [
          _c(
            "a",
            {
              staticClass: "btn_blue",
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.onSaveClick()
                }
              }
            },
            [_vm._v("Save")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n            Home\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Engineer\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Local Service Bulletin\n            "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile (Other Language) Edit\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Title\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        User Level\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Country\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Contents\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d611a3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d611a3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinOtherEdit.vue
// module id = jdkr
// module chunks = 0